// Loads Segment

import { AnalyticsWindow } from "../window"

declare let window: AnalyticsWindow

type SegmentLoaderProps = {
  swk: string // Segment write key
}

export default function analyticsSegmentLoader(
  el: HTMLElement,
  props: SegmentLoaderProps
) {
  // Here we only load Segment if analytics is permitted by the
  // Marketing Cookie Consent Manager
  function loadSegment() {
    if (!window.analytics?.init) {
      window.analytics?.load(props.swk)
    }
  }

  function handleAnalyticsIsAllowedResolved(analyticsIsAllowed: any) {
    if (analyticsIsAllowed) {
      loadSegment()
    }
  }

  function consentListener(consentEvent: any) {
    const eventType = consentEvent.event

    if (
      eventType === "cookieConsentPreferencesAvailable" ||
      eventType === "cookieConsentPreferencesUpdated" ||
      eventType === "consentOptInDefaultAvailable"
    ) {
      window.caMktgCookieConsentManager
        .isAllowed("analytics_storage")
        .then(handleAnalyticsIsAllowedResolved)
    }
  }

  window.caMktgCookieConsentManager = window.caMktgCookieConsentManager || {}
  window.caMktgCookieConsentListeners =
    window.caMktgCookieConsentListeners || []

  // If the consent manager has initialized, ask whether analytics
  // is allowed, and load Segment if it is.
  // If the consent manager hasn't initialized, add a listener
  // to be notified when consent is available.
  if (window.caMktgCookieConsentManager.initialized) {
    window.caMktgCookieConsentManager
      .isAllowed("analytics_storage")
      .then(handleAnalyticsIsAllowedResolved)
  } else {
    window.caMktgCookieConsentListeners.push(consentListener)
  }
}
